import { Routes, Route, Navigate } from 'react-router';
import { useAuth } from './lib/auth.js';
import { MainLayout } from './layouts/MainLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { EquipmentPage } from './pages/EquipmentPage';
import { PersonnelPage } from './pages/PersonnelPage';
import { Form9Page } from './pages/Form9Page';
import { Form10Page } from './pages/Form10Page';
import { Form11Page } from './pages/Form11Page';
import { TrainingPage } from './pages/TrainingPage';
import { RenewalsPage } from './pages/RenewalsPage';
import { AdminManagementPage } from './pages/AdminManagementPage';
import { TrashPage } from './pages/TrashPage';
import { DraftsPage } from './pages/DraftsPage';
import { EmailHistoryPage } from './pages/EmailHistoryPage';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  return user ? children : <Navigate to="/login" replace />;
}

function FullScreenLoader() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand-600" />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="companies" element={<CompaniesPage />} />
        <Route path="equipment" element={<EquipmentPage />} />
        <Route path="personnel" element={<PersonnelPage />} />
        <Route path="form9" element={<Form9Page />} />
        <Route path="form10" element={<Form10Page />} />
        <Route path="form11" element={<Form11Page />} />
        <Route path="training" element={<TrainingPage />} />
        <Route path="drafts" element={<DraftsPage />} />
        <Route path="renewals" element={<RenewalsPage />} />
        <Route path="email-history" element={<EmailHistoryPage />} />
        <Route path="admin" element={<AdminManagementPage />} />
        <Route path="trash" element={<TrashPage />} />
      </Route>
    </Routes>
  );
}

